import { render, staticRenderFns } from "./T1GallerySlider.vue?vue&type=template&id=3ebd90a8&scoped=true&"
import script from "./T1GallerySlider.vue?vue&type=script&lang=js&"
export * from "./T1GallerySlider.vue?vue&type=script&lang=js&"
import style0 from "./T1GallerySlider.vue?vue&type=style&index=0&id=3ebd90a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd90a8",
  null
  
)

export default component.exports